module.exports = __webpack_public_path__ + "static/media/view-slider-icon.364b534f.png";